import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        VDialog,
        {
          attrs: {
            attach: _vm.attach,
            value: _setup.value,
            fullscreen: _setup.isMobile,
            "max-width": _setup.isMobile ? undefined : _vm.width,
            transition: _setup.isMobile
              ? undefined
              : "slide-x-reverse-transition",
            "no-click-animation": "",
            "content-class": "core-drawer",
          },
          on: {
            keydown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
              )
                return null
              return _setup.emitClose.apply(null, arguments)
            },
            input: _setup.emitClose,
          },
        },
        [
          _c(
            VCard,
            {
              staticClass: "core-drawer__body",
              attrs: {
                "data-app": "",
                disabled: !_setup.value,
                "data-qa": _vm.dataQa,
              },
            },
            [
              _c(
                "div",
                { staticClass: "core-drawer__header" },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex align-center" },
                    [
                      _c(
                        VBtn,
                        {
                          attrs: {
                            icon: "",
                            text: "",
                            color: "icon-secondary",
                            "data-qa": `${_vm.dataQa}-close`,
                          },
                          on: {
                            click: function ($event) {
                              _vm.isBack
                                ? _setup.emitBack()
                                : _setup.emitClose()
                            },
                          },
                        },
                        [
                          _vm.isBack
                            ? _c(VIcon, [
                                _vm._v(
                                  "\n              ui-icon-arrow-back\n            "
                                ),
                              ])
                            : _c(VIcon, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.iconClose) +
                                    "\n            "
                                ),
                              ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "d-flex align-center text-h6 mx-4",
                          class: { "text-truncate": _vm.titleTruncate },
                          attrs: { "data-qa": "core-drawer-title" },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.title) +
                              "\n\n            "
                          ),
                          _vm._t("title-append"),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm._t("append-header"),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm._t("header"),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "core-drawer__main" },
                [_vm._t("default")],
                2
              ),
              _vm._v(" "),
              _setup.slots.footer
                ? _c(
                    "div",
                    { staticClass: "core-drawer__footer" },
                    [_vm._t("footer")],
                    2
                  )
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }